const PrivateCarPermission = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28"
         viewBox="0 0 28 28">
      <defs>
        <clipPath id="a">
          <rect width="28" height="28" transform="translate(-2062 2836)" fill="#fff" stroke="#707070" strokeWidth="1"/>
        </clipPath>
      </defs>
      <g transform="translate(2062 -2836)">
        <g transform="translate(-2061.273 2843.792)">
          <g transform="translate(0 0)">
            <path
              d="M25.239,139.707l-2.987-2.328a3.012,3.012,0,0,0-1.838-.632H12.021a3.267,3.267,0,0,0-2,.756l-3.078,2.333a1.955,1.955,0,0,1-.827.364l-.03.006-3.56.869A2.591,2.591,0,0,0,.632,142.6l-.458,1.089a2.281,2.281,0,0,0,2.087,3.145H3.382a2.658,2.658,0,0,0,5.268,0H19.523a.519.519,0,1,0,0-1.039H8.587a2.659,2.659,0,0,0-5.142,0H2.261a1.218,1.218,0,0,1-1.012-.556,1.2,1.2,0,0,1-.118-1.147l.107-.253h.815a.519.519,0,1,0,0-1.039H1.7a1.542,1.542,0,0,1,1.03-.708l.031-.007,3.56-.869a3,3,0,0,0,1.239-.546,1.867,1.867,0,0,0,1.508.774h6.216a1.221,1.221,0,0,0,1.22-1.22v-2.442h1.579v2.3a1.221,1.221,0,0,0,1.22,1.22h3.8a2.691,2.691,0,0,0,1.714-.615c.511.405.741.64.741,1.013v3.472a.619.619,0,0,1-.618.617h-.68a2.659,2.659,0,0,0-5.142,0H16.093a.519.519,0,1,0,0,1.039h2.961a2.658,2.658,0,0,0,5.268,0h.617a1.659,1.659,0,0,0,1.657-1.656v-3.472C26.6,140.761,25.967,140.273,25.239,139.707ZM6.016,148.1a1.622,1.622,0,0,1-1.62-1.62,1.62,1.62,0,0,1,3.24,0,1.622,1.622,0,0,1-1.62,1.62Zm9.444-7.869a.181.181,0,0,1-.181.181H9.063a.824.824,0,0,1-.68-.362l2.459-1.864a1.966,1.966,0,0,1,1.179-.4H15.46v2.442Zm3.838.043a.181.181,0,0,1-.181-.181v-2.3h1.3a1.964,1.964,0,0,1,1.2.412l2.35,1.832a1.658,1.658,0,0,1-.862.241H19.3Zm2.39,7.825a1.622,1.622,0,0,1-1.62-1.62,1.62,1.62,0,0,1,3.24,0A1.622,1.622,0,0,1,21.688,148.1Z"
              transform="translate(0 -136.747)"/>
            <path
              d="M275.963,253.848a.519.519,0,0,0-.52-.519h-1.051a.519.519,0,1,0,0,1.039h1.051A.519.519,0,0,0,275.963,253.848Z"
              transform="translate(-259.646 -247.273)"/>
            <path d="M257.8,311.328a.519.519,0,1,0-.281.678A.524.524,0,0,0,257.8,311.328Z"
                  transform="translate(-243.459 -301.956)"/>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default PrivateCarPermission;